import {
  Col,
  message,
  Row,
  Typography,
  Upload,
  Modal,
  Skeleton,
  Form,
} from "antd";
import { FC, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import endpoints from "../../EndPoints";
import {
  DeleteOutlined,
  EyeOutlined,
  FileOutlined,
  InboxOutlined,
} from "@ant-design/icons";


import MazakaCard from "apps/Common/MazakaCart";
import { MazakaForm } from "apps/Common/MazakaForm";

import useMazakaForm from "hooks/useMazakaForm";
import { useGetTaxCerticicates } from "../../ServerSideStates";
import { useSearchParams } from "react-router-dom";
import { addTaxCertificate, deleteTaxCertificate } from "../../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const AddOrUpdateFileUpload = (props:any) => {
  const [form] = Form.useForm();
  const { mazakaForm, formActions } = useMazakaForm(form,{submitText:"Dosya Ekle"});
  const queryClient = useQueryClient();
  const [fileList, setFileList] = useState<any[]>([]);
  const { Text } = Typography;
  const [searchParams,setSearchParams] = useSearchParams()
  const storeId = searchParams.get("storeId")
  const taxCertificates = useGetTaxCerticicates(storeId||"")

  useEffect(() => {
    if (taxCertificates.data) {
      const files = taxCertificates.data ? taxCertificates.data.data : [];

      let currentFiles = files.map((item: any) => ({
        ...item,
        name: item.name,
        isSaved: true,
      }));

      setFileList((prev: any) => currentFiles);
    }
  }, [taxCertificates.data]);

  const validateFile = (file: any) => {
    const isValidSize = file.size <= 2000000;
    if (!isValidSize) {
      message.error("Dosya Boyutu en fazla 2MB olmalı");
      return false;
    }
    return true;
  };

  const beforeUpload = (file: any) => {
    const isValid = validateFile(file);
    if (isValid) {
      setFileList((prevFileList: any) => [...prevFileList, file]);
    }
    return false;
  };

  const handleDeleteFile = (item: any) => {
    Modal.confirm({
      title: "Bu dosyayı silmek istediğinizden emin misiniz?",
      okText: "Evet",
      cancelText: "Hayır",
      onOk: async () => {
        try {
          if (item?.id) {
            await deleteTaxCertificate(item);
            openNotificationWithIcon("default", "Dosya başarıyla silindi.");
            queryClient.resetQueries({
              queryKey: endpoints.getTaxCertificates,
              exact: false,
            });
          }
          setFileList((prevFileList: any) =>
            prevFileList.filter((file: any) => file.name !== item.name)
          );
        } catch (error: any) {
          openNotificationWithIcon("default",error?.message)
        }
      },
    });
  };

  const { Dragger } = Upload;

  const handleOnFinish = async () => {
    if (fileList.length <= 0) {
      message.error("Dosya Seçimi Zorunlu");
      return false;
    }

    mazakaForm.setLoading();

    try {
      let data = fileList.filter((item)=>!item?.isSaved).map((item: any) => ({
        file: item,
        storeId: storeId,
        documentTypeId:1,
      }));

      await Promise.all(
        data.map(async (item) => {
          await addTaxCertificate(item);
        })
      );

      queryClient.resetQueries({
        queryKey: endpoints.getTaxCertificates,
        exact: false,
      });

      mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
    } catch (error: any) {
      openNotificationWithIcon("default",error?.message)
    }
  };

  return (
   
      <Col span={24}>
        <MazakaForm
          form={form}
          onFinish={handleOnFinish}
          submitButtonXPosition="left"
          initialValues={{ Active: true }}
          {...formActions}
        >

      <Row gutter={[10, 10]}>
        <Col xs={24}>
          <Dragger
            accept=".pdf"
            beforeUpload={beforeUpload}
            customRequest={() => {}}
            multiple={true}
            fileList={fileList}
            showUploadList={false}
            className="!w-full"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Vergi Lehvası</p>
            <p className="ant-upload-hint">
              Sertifikanizi buradan yükleyebilirsiniz
            </p>
          </Dragger>
        </Col>
        
        <Col xs={24}>
          <Skeleton
            loading={taxCertificates.isLoading || taxCertificates.isFetching}
          >
            {fileList.map((item) => (
              <div key={item.name} className="!flex justify-between">
                <div className="!flex items-center gap-1">
                  <FileOutlined className="!text-indigo-500" />
                  <Text>{item.name}</Text>
                </div>
                <div className="!flex gap-2">
                  <DeleteOutlined
                    className="!text-red-600"
                    onClick={() => handleDeleteFile(item)}
                  />
                  {item?.id && (
                    <>
                      <EyeOutlined
                        className="!text-indigo-600"
                        onClick={() => {
                          window.open(
                            `${
                              setBackEndUlr()
                            }/${item?.docPath}`
                          );
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            ))}
          </Skeleton>
        </Col>
      </Row>
        </MazakaForm>
      </Col>
 
  );
};

export default AddOrUpdateFileUpload;
